// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    api_url: "http://localhost:5000",
    financial_api_url: "http://localhost:5101",
    subscription_api_url: "http://localhost:5101",
    webhooks_api_url: "https://localhost:7151",
    stats_api_url: "http://localhost:5101",
    pjbank_api_url: "https://api.pjbank.com.br",
    pjbank_id: "176c095a50f7465d6484875db2b3a2d160ebb090",
    vindi_api_url: "https://sandbox-app.vindi.com.br/api/v1/public",
    vindi_public_token: "O9Y2dQRhWXGJ6jos1D-6hNXXoU5bWs0hlEpnaCyw-NQ"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
